export default "__VITE_ASSET__C7nltUmB__"